<button mat-fab class="scroll-to-top" color="accent" (click)="scrollToTop()" [@scrollAnimation]="state$ | async">
  <mat-icon>keyboard_arrow_up</mat-icon>
</button>
